import CheckBoxIcon from '@mui/icons-material/CheckBox';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Container, FormControlLabel, styled } from '@mui/material';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { RookeryRegularFont } from 'v3/styles/common';

export const FormControlLabelStyles = styled(FormControlLabel)(({ theme }) => ({
  '&, & + .MuiFormControlLabel-label': {
    marginRight: 'unset',
    marginLeft: 'unset',
  },
  span: {
    color: theme.palette.common.white,
    font: `400 0.8125rem/1.25rem ${RookeryRegularFont}`,
    alignSelf: 'start',
    marginBottom: '0.5rem',
    marginRight: 'unset',
    marginLeft: 'unset',
    whiteSpace: 'nowrap',
  },
  p: {
    font: `700 1rem/1.25rem ${RookeryRegularFont}`,
    marginTop: '0rem',
  },

  [theme.breakpoints.up('sm')]: {
    p: {
      font: `700 1rem/1.25rem ${RookeryRegularFont}`,
      marginTop: '0.6rem',
    },
  },
}));

export const SvgStyle = styled(Container)(({ theme }) => ({
  width: 0,
}));

export const CheckedBoxIconStyled = styled(CheckBoxIcon)(({ theme }) => ({
  color: theme.palette.orange.light,
}));

export const VisibilityOutlinedIconStyled = styled(VisibilityOutlinedIcon)(({ theme }) => ({
  color: theme.palette.orange.light,
}));

export const VisibilityOffOutlinedIconStyled = styled(VisibilityOffOutlinedIcon)(({ theme }) => ({
  color: theme.palette.orange.light,
}));

export const ErrorMessage = styled(BodySmallRegular)(({ theme }) => ({
  color: theme.palette.error.main,
  height: '1rem',
  marginTop: '0.2rem',
  marginBottom: '0.5rem',
}));
